import { hotTags } from "@/mocks/gossipData";

export default function Hero() {
  return (
    <section id="top" className="relative min-h-[88vh] md:min-h-[92vh] w-full overflow-hidden">
      {/* 背景图 */}
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=vibrant%20abstract%20crowd%20silhouettes%20cheering%20under%20warm%20coral%20and%20amber%20stage%20lights%20with%20floating%20speech%20bubbles%20and%20sparkles%2C%20energetic%20live%20gossip%20community%20vibe%2C%20artistic%20stylized%20illustration%2C%20deep%20warm%20tones%20with%20soft%20glow&width=1600&height=900&seq=hero-main&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-background-950/80"></div>

      {/* 内容 */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pt-32 md:pt-40 pb-16 md:pb-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur border border-white/25 text-white text-xs md:text-sm px-4 py-1.5 mb-6">
          <i className="ri-fire-fill text-accent-400"></i>
          全网热点正在实时围观中
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
        </span>

        <h1 className="font-heading text-4xl md:text-6xl text-white leading-tight mb-6">
          一起围观现场，弹幕聊到飞起
        </h1>
        <p className="max-w-2xl mx-auto text-white/85 text-base md:text-lg leading-relaxed mb-8">
          吃瓜视频网汇聚综艺名场面、影视吐槽与第一手热点。边看边聊，评论热议、
          话题讨论、视频吐槽，让你成为最前排的吃瓜群众。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <a
            href="#live"
            className="inline-flex items-center gap-2 rounded-full bg-primary-500 hover:bg-primary-400 text-background-50 font-medium px-6 py-3 whitespace-nowrap transition-colors shadow-lg shadow-primary-900/30"
          >
            <i className="ri-play-circle-fill text-xl"></i>
            进入弹幕现场
          </a>
          <a
            href="#hot"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/20 border border-white/30 text-white font-medium px-6 py-3 whitespace-nowrap backdrop-blur transition-colors"
          >
            先看看热门
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 数据条 */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mb-10 text-white">
          <div>
            <p className="font-heading text-2xl md:text-3xl text-accent-300">286万+</p>
            <p className="text-xs md:text-sm text-white/70">今日围观</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div>
            <p className="font-heading text-2xl md:text-3xl text-accent-300">1.4万+</p>
            <p className="text-xs md:text-sm text-white/70">条弹幕热议</p>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div>
            <p className="font-heading text-2xl md:text-3xl text-accent-300">24h</p>
            <p className="text-xs md:text-sm text-white/70">热点不间断</p>
          </div>
        </div>

        {/* 热词 */}
        <div className="flex flex-wrap items-center justify-center gap-2">
          {hotTags.map((tag) => (
            <a
              key={tag}
              href="#topics"
              className="px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/25 border border-white/20 text-white/85 text-xs md:text-sm whitespace-nowrap transition-colors"
            >
              #{tag}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}